const BaseComponent = require('base/base-component');
const { lunar } = require('helper/util');
const Query = require('helper/query');
const Service = require('helper/server');

class infoLine extends BaseComponent {
  init () {
    this.initCalendar();
    if ($('[name=articleDetail]').length === 0) {
      this.fetchDate();
    }
  }

  initCalendar () {
    const date = new Date();
    const _y = date.getFullYear();
    const _m = date.getMonth() + 1;
    const _d = date.getDate();
    const _nl = lunar();
    const _w = ['日', '一', '二', '三', '四', '五', '六'];
    const week = new Date().getDay();
    this.$el
      .find('.today')
      .text(_y + '年' + _m + '月' + _d + '日 星期' + _w[week] + ' 农历' + _nl);
  }

  fetchDate () {
    const query = new Query();
    const PID = query.get('PID');
    const param = PID ? { PID } : {};
    this.articleId && (param.articleId = this.articleId);
    return Service.visitCount(param)
      .then((resp) => {
        this.fillCount(resp);
      });
  }

  fillCount ({ total = 0, today = 0, article = 0 }) {
    const $count = this.$el.find('.counting');
    $count.find('.total').text(total);
    $count.find('.today').text(today);
    if (article) {
      $('[name="visitsCount"]').val(article);
    }
  }
}
module.exports = infoLine;
